<template>
  <div>
    <div class="row mt-s">
      <div class="col-lg-2 col-xs-4">
        <label>Description</label>
      </div>

      <div class="col-lg-10 col-xs-8">
        {{ model.description }}
      </div>
    </div>

    <div class="row mt-s">
      <div class="col-lg-2 col-xs-4">
        <b>Attachments</b>
      </div>
      <div class="col-lg-10 col-xs-8">
        <ul>
          <li
            v-for="file in model.files"
            :key="file.id"
            class="list-unstyled mt-xxxs"
          >
            <a @click.prevent="handleDownloadFile(event, file)">
              {{ file.original_name }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="row mt-s">
      <div class="col-lg-2 col-xs-4">
        <b>Notes</b>
      </div>
      <div class="col-lg-10 col-xs-8">
        <div
          class="notes ql-editor"
          v-html="model.notes"
        />
      </div>
    </div>

    <hr>

    <div class="row mt-s">
      <div class="col-xs-2">
        <b>Issued At</b>
      </div>
      <div class="col-xs-10">
        {{ formatDate(model.issued_at) }}
      </div>
    </div>

    <div class="row mt-s">
      <div class="col-xs-2">
        <b>Expiry At</b>
      </div>
      <div class="col-xs-10">
        {{ formatDate(model.expiry_at) }}
      </div>
    </div>
    <div class="row mt-s">
      <div class="col-xs-12">
        <p v-if="getExpiryMessage.hasReminders">
          Notifications sent
          <b>{{ getExpiryMessage.reminder }}</b>
          day(s) prior to expiry to
          <b>{{ getExpiryMessage.to }}</b>
        </p>

        <p v-if="!getExpiryMessage.hasReminders">
          <b>{{ getExpiryMessage.reminder }}</b>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import HelperDate from "@helpers/dates";
export default {
  components: {},
  props: {
    event: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["eventDownloadFile"],
  data() {
    return {
      expiryMessage: null
    };
  },
  computed: {
    model() {
      return this.event;
    },
    getExpiryMessage() {
      const event = this.model;
      let reminderList = event.reminders;
      if (
        !reminderList ||
        !reminderList.length ||
        (!event.manager && !event.trainee)
      ) {
        return {
          hasReminders: false,
          reminder: "No warnings",
          to: []
        };
      }

      const to = [];

      if (event.manager) {
        to.push("Manager");
      }

      if (event.trainee) {
        to.push("Trainee");
      }

      reminderList = reminderList.filter(item => {
        return parseInt(item.value, 10) > 0;
      });

      if (reminderList.length == 1) {
        return {
          hasReminders: true,
          reminder: reminderList[0].value,
          to: to.join(", ")
        };
      }

      const valueList = [];

      reminderList.forEach(item => {
        valueList.push(parseInt(item.value, 10));
      });

      valueList.sort((a, b) => a - b);

      const last = valueList.pop();
      const message = valueList.join(", ").concat(" & ", last);

      return {
        hasReminders: true,
        reminder: message,
        to: to.join(", ")
      };
    }
  },
  methods: {
    formatDate(date) {
      return HelperDate.formatDate(date);
    },
    handleDownloadFile(event, file) {
      this.$emit("eventDownloadFile", { event, file });
    }
  }
};
</script>

<style lang="scss"></style>
